export const countCsvDataRows = (csv: string): number => {
  let records = 0;
  let inQuotes = false;
  let recordHasContent = false;

  for (let index = 0; index < csv.length; index++) {
    const character = csv[index];

    if (inQuotes) {
      if (character !== '"') continue;
      if (csv[index + 1] === '"') index++;
      else inQuotes = false;
      continue;
    }

    if (character === '"') {
      inQuotes = true;
      recordHasContent = true;
    } else if (character === '\n') {
      if (recordHasContent) records++;
      recordHasContent = false;
    } else if (character !== '\r') {
      recordHasContent = true;
    }
  }

  if (recordHasContent) records++;

  return Math.max(0, records - 1);
};
